import React from 'react'
import OrgHome from '../components/mulecules/home/mul-home'

function Home({setModalLogOut}) {
    return (
        <div>
            <OrgHome setModalLogOut={setModalLogOut}/>
        </div>
    )
}

export default Home
